import React, { Component, Fragment } from 'react';
import axios from 'axios';

import { Upload, Button, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

class FileUpload extends Component {
  state = {
    fileList: []
  };

  getBase64 = (img, callback, sizeCheck) => {
    let sizeOk = true;
    
    // 이미지 파일이고 상품기본이미지 업로드일경우만 사이즈 체크
    if (this.props.fileType === 'img' && this.props.imgSizeCheck === true) {
      const reader = new FileReader();
      let sizeImg = document.getElementById('sizeImg');
      // 한번 그려준뒤에 사이즈를 구해야 된다.(처음에 사이즈 못가져옴)
      reader.addEventListener('load', () => {
        callback(reader.result);
        sizeImg.setAttribute('src', `${reader.result}`);
        sizeImg.setAttribute('style', "display;");
      });
      reader.readAsDataURL(img);
      reader.onload = () => {
        sizeImg.setAttribute('src', `${reader.result}`);
        
        // console.log("sizeImg", sizeImg);
        
        let width = sizeImg.clientWidth;
        let height = sizeImg.clientHeight;

        // console.log("width", width);
        // console.log("height", height);
        sizeImg.setAttribute('style', "display:none;");
        if (width !== height) {
          notification.error({placement: 'bottomLeft', message: `정사각형 사이즈만 업로드 가능합니다.`, duration: 2});
       // if (width > 100 || height > 100) {
       //   notification.error({placement: 'bottomLeft', message: `100 X 100 사이즈만 업로드 가능합니다.`, duration: 2});
          sizeOk = false;
        }
        sizeCheck(sizeOk);
      };
    } else {
      sizeCheck(sizeOk);
    }
  };

  handleUpload = (file) => {
    // const { fileList } = this.state;
    const formData = new FormData();
    formData.append('file', file);

    this.getBase64(
      file, 
      evenLoad =>{},
      sizeCheck => {
        if (sizeCheck === true) {
          axios({
            method: 'post',
            url: `${process.env.REACT_APP_URL}/file/fileUpload`,
            headers: {
              'Content-Type': 'application/json',
            },
            data: formData
          })
          .then((res) => {
            // console.log('success', res.data);
            if (res.data.fileId !== undefined && res.data.fileId !== null) {
              let fileData = {
                ...res.data.uploadedFileList[0],
                fileId: res.data.fileId
              };
              // console.log("FileUpload", fileData);
              if (this.props.onFileInfo !== undefined) {
                  this.props.onFileInfo(fileData);
              }
            }
          })
          .catch((err) => {
            console.log('err', err);
            notification.error({placement: 'bottomLeft', message: `올릴수 없는 파일입니다.`, duration: 2});
          });
        }
      }
    );
  };

  render() {
    // const { fileList, fileInfoList } = this.state;
    const { fileType, imgSizeCheck } = this.props;
    const props = {
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        if (fileType !== undefined && fileType !== null && fileType === 'img') {
          const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
          if (!isJpgOrPng) {
            notification.error({placement: 'bottomLeft', message: `이미지파일(JPG/PNG)을 선택해주세요.`, duration: 2});
            return false;
          }
          // const isLt2M = file.size / 1024 / 1024 < 2;
          // if (!isLt2M) {
          //   notification.error({placement: 'bottomLeft', message: `이미지 사이즈는 2MB를 넘을 수 없습니다.`, duration: 2});
          //   return false;
          // }
        }
        this.setState(state => ({
          fileList: [...state.fileList, file],
        }));
        this.handleUpload(file);
        return false;
      },
      fileList: null
    };

    return (
      <Fragment>
          <Upload {...props}>
            <Button>
              <UploadOutlined /> 파일선택
            </Button>
          </Upload>
          {(imgSizeCheck !== undefined && imgSizeCheck !== null && imgSizeCheck === true) &&
            <img id="sizeImg" src="" alt="" style={{display:"none"}} />
          }
      </Fragment>
    );
  }

}

export default FileUpload;
